import apiAdmin from '@/utils/apiAdmin';
import { findIndex } from 'lodash';
import { defineStore } from 'pinia';

import {LocaleListItem, LocaleListState} from '@/types/Locale';

export const useLocaleStore = defineStore('localeList', {
  state: ():LocaleListState => ({
    items: []
  }),
  getters: {
    codes(state){
      return state.items.map(item=>item.code);
    }
  },
  actions: {
    async getItems(){
      const response = await apiAdmin.get('/api/locale');
      this.setItems(response.data);
    },
    setItems(payload: LocaleListItem[]){
      this.items = payload;
    },
    async addItem(payload: LocaleListItem){
      const item = {...payload};
      const response = await apiAdmin.post('/api/locale', item);
      this.items.push(response.data);
    },
    async putItem(payload: LocaleListItem){
      const item = {...payload};
      const response = await apiAdmin.put(`/api/locale/${item.idx}`, item);
      const selectedIdx = findIndex(this.items, (items:LocaleListItem) => {
        return items.idx === item.idx;
      });
      this.items[selectedIdx] = response.data;

    },
    async deleteItem(idx: number){
      const response = await apiAdmin.delete(`/api/locale/${idx}`);
      const selectedIdx = findIndex(this.items, (item:LocaleListItem) => {
        return item.idx === idx;
      });

      this.items.splice(selectedIdx, 1);

    }
  }
});


/*
GET /api/locale
Content-Type: application/json
Accept: application/json
Cookie : {Olive 관련 cookie 포함 필요}
[
    {
        "idx": 1,
        "name": "블레이드 앤 소울2",
        "appGroupCode": "bns2",
        "createAdmin": "crystal",
        "createDate": "2022-03-31T15:48:16+09:00"
    }
]
*/
